/** Shared dark dashboard tokens + helpers for Accounts & Transactions screens. */

export const MONTHS = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];

export const fmt = (v) => parseFloat(v || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

/** Signed currency for net P/L (positive = surplus). */
export const fmtSignedNet = (n) => {
    const v = parseFloat(n ?? 0);
    const prefix = v >= 0 ? '+' : '−';
    return `${prefix}$${fmt(Math.abs(v))}`;
};

export const D = {
    bg: '#13141a',
    card: '#1c1d26',
    cardHeaderBg: 'rgba(28, 29, 38, 0.72)',
    border: '#353849',
    fg: '#f2f2f5',
    muted: '#8b8d98',
    primary: '#7387ff',
    primaryFg: '#fafafa',
    secondary: 'rgba(255,255,255,0.06)',
    secondaryStrong: 'rgba(255,255,255,0.1)',
    success: '#4ade80',
    successBg: 'rgba(74, 222, 128, 0.12)',
    spend: '#fb7185',
    spendBg: 'rgba(251, 113, 133, 0.12)',
    income: '#5eead4',
    chartPrimary: '#7387ff',
};

export const selectMenuProps = {
    PaperProps: {
        sx: {
            bgcolor: D.card,
            color: D.fg,
            border: `1px solid ${D.border}`,
            borderRadius: 2,
            boxShadow: '0 12px 40px rgba(0,0,0,0.45)',
            maxHeight: 360,
            '& .MuiList-root': { bgcolor: D.card, py: 0.5 },
            '& .MuiMenuItem-root': {
                color: D.fg,
                fontSize: '0.875rem',
            },
            '& .MuiMenuItem-root em': { color: D.muted, fontStyle: 'normal' },
            '& .MuiMenuItem-root:hover': { bgcolor: D.secondaryStrong },
            '& .MuiMenuItem-root.Mui-focusVisible': { bgcolor: D.secondaryStrong },
            '& .MuiMenuItem-root.Mui-selected': {
                bgcolor: `${D.primary}33`,
                color: D.fg,
            },
            '& .MuiMenuItem-root.Mui-selected:hover': { bgcolor: `${D.primary}44` },
        },
    },
};

/** Larger dropdown menus for the dedicated Transactions screen (easier to tap). */
export const selectMenuPropsLarge = {
    PaperProps: {
        sx: {
            ...selectMenuProps.PaperProps.sx,
            maxHeight: 520,
            '& .MuiMenuItem-root': {
                color: D.fg,
                fontSize: '0.95rem',
                minHeight: 44,
                py: 1,
            },
            '& .MuiListSubheader-root': {
                fontSize: '0.82rem',
            },
        },
    },
};
